import React, { useEffect, useState } from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { useApolloClient, useMutation, useQuery } from '@apollo/client';
import { GET_TOKEN, LOGIN } from '../gql/auth';
import Loading from './layout/Loading';
import { loginUser } from '../actions/auth';

const useQueryParams = () => new URLSearchParams(useLocation().search);

const Login = () => {
  const client = useApolloClient();
  const query = useQueryParams();
  const [loading, setLoading] = useState(true);
  const { data } = useQuery(GET_TOKEN);
  const [login] = useMutation(LOGIN, {
    // eslint-disable-next-line no-shadow
    onCompleted({ login }) {
      loginUser({ client, login });
    },
  });
  const token = query.get('token');
  const targetUrl = query.get('targetUrl') || '/';
  useEffect(() => {
    login({ variables: { token } });
  }, []);
  useEffect(() => {
    if (data.loginLoading === false) {
      setLoading(false);
    }
    return () => {
      client.writeQuery({
        query: GET_TOKEN,
        data: {
          loginLoading: true,
        },
      });
    };
  }, [data]);

  if (loading) {
    return <Loading />;
  }
  return <Redirect to={targetUrl} />;
};

export default Login;
